const tagNumber = '2.25.3.0-d';
const PREFIX_URL = '/api/';
const BASE_URL = `${process.env.REACT_APP_API_JAVA}${PREFIX_URL}`;
const URL_POD_SPACE = 'https://podspace.pod.ir/api/files';
const URL_PODIUM = process.env.REACT_APP_URL_PODIUM;
const URL_PAY = process.env.REACT_APP_PAY_URL;
const URL_REACT_APP = process.env.REACT_APP_URL;
const BUSINESS_EXCEPTIONS_SSO_ID = process.env.REACT_APP_BUSINESS_ID_EXCEPTIONS?.split(',') || [];

export { BASE_URL, URL_POD_SPACE, URL_PODIUM, URL_PAY, URL_REACT_APP, BUSINESS_EXCEPTIONS_SSO_ID  , tagNumber};